// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'inte... Remove this comment to see the full error message
import Interframe from 'interframe';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'inte... Remove this comment to see the full error message
import { Deferred } from 'interframe/utils/Promise';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import * as PostMessageTypes from 'editor-iframe-lib/constants/PostMessageTypes';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'edit... Remove this comment to see the full error message
import { syncIframeState } from 'editor-iframe-lib/redux/actions/syncActions';
import { getPreviewOrigin } from './previewUtils';
class PreviewController {
  constructor() {
    this.setStore = store => {
      this.store = store;
    };
    this.start = targetWindow => {
      this.deferred = new Deferred();
      this.ready = false;
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
      this.messenger = new Interframe(getPreviewOrigin(), targetWindow);
      this.messenger.subscribe(this.receiveMessage);
      return this.deferred.promise;
    };
    this.receiveMessage = message => {
      switch (message.type) {
        case PostMessageTypes.IFRAME_ROOT_MOUNTED:
          {
            this.deferred.resolve();
            this.ready = true;
            break;
          }
        default:
          break;
      }
    };
    this.postMessage = (message, type) => {
      if (this.messenger) {
        this.messenger.postMessage(message, type);
      }
    };
    this.syncIframeState = (diff = {}) => {
      // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
      this.postMessage({
        type: PostMessageTypes.REDUX_ACTION,
        payload: syncIframeState({
          diff
        })
      });
    };
  }
}
export default new PreviewController();